import { POS_ROUTE } from "../../../constants/constants";

export const CURRENT_USER_PROFILE_ROUTE = POS_ROUTE + "/profile"
export const ALL_USERS_LIST_ROUTE = POS_ROUTE + "/all-users"